export const BloodPressure = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_109_841)">
      <path
        d="M13.25 19.0002L12.25 20.0002L4.75 12.5722C4.2553 12.0908 3.86564 11.5122 3.60554 10.8728C3.34545 10.2334 3.22056 9.54713 3.23873 8.85711C3.25691 8.16709 3.41776 7.48831 3.71115 6.86351C4.00455 6.23871 4.42413 5.68143 4.94348 5.22676C5.46283 4.77208 6.0707 4.42987 6.72881 4.22166C7.38691 4.01345 8.081 3.94376 8.76736 4.01698C9.45373 4.0902 10.1175 4.30473 10.7169 4.64708C11.3162 4.98943 11.8382 5.45218 12.25 6.00618C13.0452 4.94491 14.2295 4.24303 15.5423 4.05493C16.855 3.86683 18.1887 4.20792 19.25 5.00318C20.3113 5.79843 21.0131 6.98269 21.2012 8.29545C21.3893 9.6082 21.0482 10.9419 20.253 12.0032"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.25 16L17.25 19H21.25L19.25 22"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_841">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);

export const WeightIcon = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_109_862)">
      <path
        d="M12.25 12C14.25 9.04 12.25 5 11.25 4C11.25 7.038 9.477 8.741 8.25 10C7.024 11.26 6.25 13.24 6.25 15C6.25 16.5913 6.88214 18.1174 8.00736 19.2426C9.13258 20.3679 10.6587 21 12.25 21C13.8413 21 15.3674 20.3679 16.4926 19.2426C17.6179 18.1174 18.25 16.5913 18.25 15C18.25 13.468 17.194 11.06 16.25 10C14.464 13 13.459 13 12.25 12Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_862">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);

export const PulseIcon = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_109_848)">
      <path
        d="M3.75 12H8.25L9.75 6L13.75 18L15.75 9L17.25 12H21.75"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_848">
        <rect width="24" height="24" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
);

export const SaturationIcon = (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_109_855)">
      <path
        d="M10.25 13.5C9.48743 13.9403 8.89145 14.6199 8.55448 15.4334C8.21752 16.2469 8.1584 17.1488 8.3863 17.9994C8.6142 18.8499 9.11638 19.6015 9.81496 20.1375C10.5135 20.6736 11.3695 20.9641 12.25 20.9641C13.1305 20.9641 13.9865 20.6736 14.685 20.1375C15.3836 19.6015 15.8858 18.8499 16.1137 17.9994C16.3416 17.1488 16.2825 16.2469 15.9455 15.4334C15.6086 14.6199 15.0126 13.9403 14.25 13.5V5C14.25 4.46957 14.0393 3.96086 13.6642 3.58579C13.2891 3.21071 12.7804 3 12.25 3C11.7196 3 11.2109 3.21071 10.8358 3.58579C10.4607 3.96086 10.25 4.46957 10.25 5V13.5Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.25 9H14.25"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_109_855">
        <rect width="24" height="24" fill="white" transform="translate(0.25)" />
      </clipPath>
    </defs>
  </svg>
);
